import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-top-rated-content',
  templateUrl: './top-rated-content.component.html',
  styleUrls: ['./top-rated-content.component.css']
})
export class TopRatedContentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
